import EmailEditor from './EmailEditor.vue'

export default EmailEditor;
